export default class PriceSuggestion {
	constructor(container, currency_switcher) {
		this.container = container;
		this.currency_switcher = currency_switcher;
		this.prices = JSON.parse(this.container.dataset.suggestionPrices);
		this.price_spans = this.container.querySelectorAll('.convertable_price');

		this.price_spans.forEach(price_span => {
			price_span.dataset.currency = this.currency_switcher.currency_code;
		});

		const
			transport_selector =
				container.closest('form.offer').querySelector('.transport');

		if (transport_selector) {
			const transport_selector_button =
				transport_selector.querySelector('button');

			transport_selector_button.addEventListener('change', () => {
				const
					selected_transport = transport_selector.querySelector('.selected');

				if (!selected_transport) {
					container.classList.add('hidden');
					return;
				}

				this.container.dataset.transportTypeId =
					selected_transport.dataset.typeId;

				this.renew();
			});

			transport_selector_button.dispatchEvent(new Event('change'));
		} else {
			this.renew();
		}
	}

	renew() {
		const price_values = this.prices[this.container.dataset.transportTypeId];

		if (!price_values) {
			this.container.classList.add('hidden');
			return;
		}

		this.price_spans.forEach(price_span => {
			price_span.dataset.value = price_values[price_span.dataset.priceType];
		});

		this.currency_switcher.update_currency();
		this.container.classList.remove('hidden');
	}
}
